import { Box, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import type BackendService from '../../../services/admin/BackendService';
import DocumentLibraryPanel from './DocumentLibraryPanel';
import VideoLibraryPanel from './VideoLibraryPanel';

interface LibraryPanelProps {
  fundOpportunityId: string;
  backendService: BackendService;
}

export default function LibraryPanel({ fundOpportunityId, backendService }: LibraryPanelProps) {
  const [tab, setTab] = useState<'videos' | 'documents'>('videos');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Tabs value={tab} onChange={(_, v) => setTab(v as 'videos' | 'documents')}>
        <Tab value="videos" label="Videos" />
        <Tab value="documents" label="Documents" />
      </Tabs>
      <Box sx={{ flex: 1, overflowY: 'auto', pt: 2 }}>
        {tab === 'videos' ? (
          <VideoLibraryPanel
            fundOpportunityId={fundOpportunityId}
            backendService={backendService}
          />
        ) : (
          <DocumentLibraryPanel
            fundOpportunityId={fundOpportunityId}
            backendService={backendService}
          />
        )}
      </Box>
    </Box>
  );
}
